function PassengerNameForm({ fullName, onChange }) {
  return (
    <div className="space-y-6 max-w-xl">
    
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Full Name
        </label>

        <input
          type="text"
          value={fullName}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter full name"
          className="
            w-full px-4 py-3
            border border-gray-300 rounded-lg
            focus:ring-2 focus:ring-blue-500 focus:border-blue-500
          "
        />
      </div>
    </div>
  );
}

export default PassengerNameForm;
